module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("CHAPTER 2")])])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("C")])])])]), _vm._v("ole was soaked to his skin. The wind lashed him, and rain stung his shoulders and back through his sopped shirt. The narrow key seemed to shudder with each roll of thunder. Yet, through it all, he thought he’d heard a shriek.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He lifted his head. It wasn’t just the shrill of wind through the boat’s rigging. Something almost human…")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Squinting into the rain, he peered around the thick patch of mangroves to check on his sloop. Though "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Streamin’")])]), _vm._v(" had listed from the pounding of the surf, she looked all right. But something was sprawled on the beach beside the hull, as if there had been an accident and the prow had hit someone.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Still keeping low, he went to see what had come in. His breath huffed out as if he’d been hit in the gut; his heart pounded even harder. A woman—it looked like a drowned mermaid!")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("No, no, of course not, he told himself as he bent over the sprawled figure. The short-sleeved, full-length, silvery-green wet suit clung to her curves so tightly it looked painted on. It was designed with a fin-and-scale pattern to look as if she had a tail. Long legs, that was all. Her shoulder-length, auburn hair clung to her head. Her graceful, limp arms were in a ballerina pose, as if she would dance. Was she dead?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Afraid to roll her face up—instinct in case she had spine or head injuries from hitting his boat—he felt for the pulse at the base of her throat. She felt cold and, despite her tan, her cheek and chin looked pale and waxy, almost as if she were a life-size doll. She had a faint pulse, but she was so still he wasn’t certain she was breathing. Carefully, he turned her over, faceup.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She had marks on her face from a diving mask, but he knew this woman! Or else he knew her sister. She was one of the twins who owned the Two Mermaids Marine Search and Salvage Shop in Turtle Bay, not far from his own business. He’d had an impromptu lunch with one of them—Briana—the day she’d been scraping the hull of the Richardson yacht when he was paneling the salon with Santos mahogany. He’d been going through the divorce then and was only dating his sloop, or he would have called her. Thank God, she was alive, but she might not be soon if she didn’t take a breath.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Ignoring the slashing rain and continued threat of lightning, he pulled her carefully up out of the slosh of the surf. Hunched over her, just beyond the breaking waves, he started mouth-to-mouth resuscitation. He hadn’t done that on anyone since he’d tried to save his father when he’d found him on the floor, and that was too late. What had happened to this woman? Surely she hadn’t been swimming in the storm.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She seemed slender and small, but he knew she was a vital, strong woman. "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Come on, baby. Come on back. Breathe for me. Let my lips warm yours, sweetheart. Come on, come on.")])])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("It had amused him, then impressed him, that two women would run such a rough-and-tumble business, especially when their competition across the bay was a gruff, tough guy who pretty much had a monopoly on search and salvage in the area. The women mostly did light salvage, none of the heavy stuff with dredging and demolition like Sam Travers, but search and salvage was always a risky business.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Come on, baby, I know you’re spunky. Take my breath. Come on, you beautiful little mermaid!")])])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He started to panic, his sweat mingling with the rain, even in the cool rush of wind. After what seemed an eternity, her mouth moved against his. He stopped and looked down into her face, glazed by rain and gulf water. Her thick eyelashes, plastered to her ashen cheeks, flickered. She frowned and moaned.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Hey, mermaid!” he said, feeling like a fool, but he couldn’t remember her last name and wasn’t sure which twin this was. Still, he used the name he knew, one he’d remembered for months now because it had seemed to suit her. It had reminded him of the word "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("brio,")])]), _vm._v(" for her enthusiasm and verve that time they’d talked and eaten together. He’d felt an instant attraction to her, a surge of desire that he’d tried to control by being overly polite and teasing that day. “Briana?” he said, his voice shaking. “Briana!”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She slitted her eyes open. “Daria?” she said, and started to cough up water.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He rolled her over slightly and braced her with one arm around her. One hand held her forehead steady like his mother used to do for him years ago when he threw up. It wasn’t until he saw the burn marks on her limp left wrist, like a big bracelet around her dive watch, that he realized she might have been hit by lightning. He laid her back down on the sand, leaning over her, trying to keep the rain and wind off her with his body.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Where’s Daria?” he asked. “What happened?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("No answer. He gasped when he saw her eyes were dilated, the huge, black pupils eating up the gray-green of the irises, the color of the sea. He had to get her medical help—now. He couldn’t wait for the storm to end. But there was no way to get an EMS vehicle out here, and a medical chopper couldn’t fly in this mess. He could get on his radio and Mayday the coast guard, but it would take them time to get out here and he could have her into Naples by then—if all went well.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He had to hurry. His mermaid had evidently fainted or gone comatose at his feet.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He put his hand on her chest to be sure she was still breathing. Yes, shallow but steady. Though he hated to take the chance with the sloop, he had to risk sailing in with her right now. At least in an all-wooden boat—if he could get it off the beach—they might be able to escape the lightning. It would be rough going, but he had to try.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Praying she had no broken bones or internal injuries, he lifted her into the sloop and gently lashed her down. He stripped off his polo shirt and, though it was soaked, too, laid it over her upper torso. One of his customers had been hit by lightning on a golf course, and his doctor had told him that fast medical help had saved him from severe complications. He could not bear it if this beautiful, bold woman were permanently hurt. That old adage about being responsible for someone if you saved their life hit him hard, but he hadn’t saved her yet.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Straining every muscle in his body to get some lift for "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Streamin’,")])]), _vm._v(" Cole tried to time pushing the sloop off the sand with the roll of the surf, but the power of the waves and wind beat it back. Waves could easily swamp or capsize a boat leaving a beach. His fourteen-foot sloop, which he knew more intimately than he knew any woman right now, fought him hard.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("But he saw the wind had clocked around to the north. He could use the power of the sails to propel the sloop off the beach. In a hand-over-hand effort, he pulled the main halyard until the sail had reached the top of the mast. Then with a grunting, grinding heave, Cole pushed the bow of the boat off the beach toward the pounding surf. As the little sloop swung her bow through the wind, the sails filled, and she moved into deeper water. He pulled himself into the cockpit and grabbed the tiller in one hand while securing the mainsheet with the other. As he lowered the centerboard, the sloop began to feel her sea legs. She quickly picked up speed on a beam reach and cut through the water like a race car.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("But it was brutal sailing. He had to step over his mermaid when he played the mainsheet and sit outboard to balance the heavy heeling. He feared a broach roll and had to adjust the tiller constantly. Every time the boat heeled, water sloshed over the side to soak Briana. She came to again, shoved her head and shoulder up by one elbow and screamed, “Sharks! Daria, sharks!”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Lie down!” Cole shouted. “Down or the boom will get you when we tack. You’re with me, you’re all right. Lie down! There are no sharks. I won’t let them get you or Daria!”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("That seemed to calm her, and that trust clenched at his heart. He had to get her to safety, see that she was taken care of. She was out of her head, and his friend had said amnesia and brain damage could be some of the aftereffects of a lightning strike. If he could just let go of the tiller and sit still a second in this raging chaos, he could call for help, have someone meet him at the marina with a squad for her. But he couldn’t tell where he was. To the pier yet? He didn’t want to hit the pier.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("As for the sharks, she could not possibly have seen them just now, but she was dead on: he glanced ahead and saw several bull sharks racing right with them, just like the ones in the picture in his office. The Winslow Homer painting called "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("The Gulf Stream")])]), _vm._v(" was the reason he’d named his company Gulf Stream Yacht Interiors, the reason he’d named this sloop "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Streamin’")])]), _vm._v(". But these sharks almost bumping the boat were no work of art—this race was life and death for real.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ec64cd24","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/belowthesurface_ch02.vue
// module id = 69
// module chunks = 0